import React from "react";
import CotizacionAPersonalRecuperarCortoPlazo from "../../components/CotizacionAccidentePersonal/CotizacionAPersonalRecuperarCortoPlazo";

const ContainerCotizacionAPersonalRecCortoPlazo =()=> 
 
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <CotizacionAPersonalRecuperarCortoPlazo/>
          </div>
        </div>
      </main>
 

export default ContainerCotizacionAPersonalRecCortoPlazo
